import i18n from '@/locales/i18n';
import moment from 'moment';

function switchTerritoryAcessNotification(status: number, params: any, frig = true) {
  switch (status) {
    case 2:
      return {
        type: frig ? 'info' : 'question',
        text: frig
          ? i18n.t('solicited_frigo', { territoryName: params.territoryName }).toString()
          : i18n.t('solicted_prod', { territoryName: params.territoryName, frigName: params.issuerName }).toString(),
      };
    case 3:
      return {
        type: 'info',
        text: frig
          ? i18n.t('solicted_frig_refused', { receiverName: params.receiverName, territoryName: params.territoryName }).toString()
          : i18n.t('solicicted_prod_refused', { frigName: params.issuerName }).toString(),
      };
    case 4:
      return {
        type: 'info',
        text: frig
          ? i18n.t('solicited_frig_accepted', { receiverName: params.receiverName, territoryName: params.territoryName }).toString()
          : i18n.t('solicited_prod_accepted', { territoryName: params.territoryName }).toString(),
      };
    default:
      return {
        type: 'default',
        text: '',
      };
  }
}

function getTextAppointiment(date: string, type: string) {
  const diffDays = moment().diff(date, 'days');
  const ONE_DAY_BEFORE = -1;

  if (diffDays === ONE_DAY_BEFORE) {
    return i18n.t('appointment_tomorrow', { type }).toString();
  }

  return i18n.t('appointment_days', { type, diffDays: Math.abs(diffDays) }).toString();
}

function getTextPayment(date: string, params: any) {
  const diffDays = moment().diff(date, 'days');
  const ONE_DAY_BEFORE = -1;
  const monthName = moment(date).format('MMMM');

  if (!diffDays) return `Hoje se vence o prazo do boleto do território ${params.territoryName} do mês ${monthName}`;

  if (diffDays > 0) {
    return `O boleto do território ${params.territoryName} do mês de ${monthName} está vencido! 
  Acesse os detalhes deste território para visualizar mais informações.`;
  }

  if (diffDays === ONE_DAY_BEFORE) {
    return `Amanhã vence o boleto do ${monthName}`;
  }

  return `Resta ${diffDays} dia(s) para o boleto do mês ${monthName} se vencer`;
}

export default function switchNotificationType(type: number, status: number, params: any, frig = true) {
  switch (type) {
    case 1:
      return { ...switchTerritoryAcessNotification(status, params, frig), tag: 'Acesso ao território' };
    case 2:
      return {
        type: 'info',
        text: getTextPayment(params.date, params),
        tag: 'Pagamento',
      };
    case 3:
      return {
        type: 'info',
        text: getTextAppointiment(params.date, 'Geomonitoramento'),
        tag: 'Apontamento',
      };
    case 4:
      return {
        type: 'info',
        text: getTextAppointiment(params.date, 'Autovistória'),
        tag: 'Apontamento',
      };
    default:
      return {
        type: 'default',
        text: '',
        tag: '',
      };
  }
}
